export const APP_COLORS = {
  // Colores principales
  primary: '#1a4bff', // Azul principal
  secondary: '#e6ebff', // Azul claro
  accent: '#3b82f6', // Azul acento
  
  // Variantes semánticas
  success: '#22c55e',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#3b82f6',
  
  // Colores de texto
  text: {
    primary: '#1e293b',
    secondary: '#64748b',
    light: '#94a3b8'
  },
  
  // Colores de fondo
  background: {
    primary: '#ffffff',
    secondary: '#f8fafc',
    accent: '#f1f5f9'
  }
};

// Tipos de negocios disponibles en el sistema
export const BUSINESS_TYPES = [
  { id: 'standard', name: 'Estándar', description: 'Configuración genérica para cualquier tipo de negocio' }
];

// Verticales del producto (= columna tenants.vertical). Para segmentar notificaciones por
// línea de negocio. Extensible: agregar aquí nuevas verticales (ej. lets move) conforme existan.
export const VERTICALS = [
  { id: 'lealtad', name: 'Lealtad' },
  { id: 'dental', name: 'Dental' },
];

// Configuraciones específicas por tipo de negocio
export interface BusinessTypeConfig {
  clientLabel: string;
  pointsLabel: string;
  visitLabel: string;
  checkInButtonLabel: string;
  features: {
    birthdayReminders: boolean;
    clientHistory: boolean;
    loyaltyLevels: boolean;
    appointmentSystem: boolean;
    inventory: boolean;
  };
}

// Configuraciones predeterminadas por tipo de negocio
export const BUSINESS_TYPE_CONFIGS: Record<string, BusinessTypeConfig> = {
  standard: {
    clientLabel: 'Cliente',
    pointsLabel: 'Puntos',
    visitLabel: 'Visita',
    checkInButtonLabel: 'Registrar Visita',
    features: {
      birthdayReminders: true,
      clientHistory: true,
      loyaltyLevels: true, // Se mantiene habilitado para conservar funcionalidad de cafeterías
      appointmentSystem: false,
      inventory: false
    }
  }
};